/**
 *  @class
 *  @function LocalizationForm
 */
const THEME_DEFAULT_COUNTRY_CODE = 'US';
const THEME_COUNTRY_PREFERENCE_KEY = 'theme_country_preference';
let themeDefaultCountryCheckDone = false;

function _debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.debouncedOnSubmit = _debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.boundCloseCountryPanels = this.closeCountryPanels.bind(this);
      this.boundHandleEscape = this.handleEscape.bind(this);
      this.inputs.forEach(item => item.addEventListener('change', (event) => {
        if (event.target.name === 'country_code') {
          this.saveCountryPreference(event.target.value);
        }
        this.updateIcons();
        this.debouncedOnSubmit(event);
      }));
      this.setupCountryDropdowns();
      this.applyDefaultCountryIfNeeded();
      this.updateIcons();
    }
    saveCountryPreference(countryCode) {
      if (!countryCode) return;
      localStorage.setItem(THEME_COUNTRY_PREFERENCE_KEY, countryCode);
    }
    applyDefaultCountryIfNeeded() {
      if (themeDefaultCountryCheckDone) return;

      const select = this.form.querySelector('select[name="country_code"]');
      if (!select) return;

      themeDefaultCountryCheckDone = true;

      if (localStorage.getItem(THEME_COUNTRY_PREFERENCE_KEY)) return;
      if (select.value === THEME_DEFAULT_COUNTRY_CODE) return;

      const defaultOption = Array.from(select.options).find((option) => option.value === THEME_DEFAULT_COUNTRY_CODE);
      if (!defaultOption) return;

      select.value = THEME_DEFAULT_COUNTRY_CODE;
      this.form.submit();
    }
    setupCountryDropdowns() {
      this.querySelectorAll('.localization-select--country .localization-country-trigger').forEach((trigger) => {
        const wrapper = trigger.closest('.localization-select--country');
        const panel = wrapper?.querySelector('.localization-country-panel');
        const select = wrapper?.querySelector('select[name="country_code"]');
        if (!wrapper || !panel || !select) return;

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const isOpen = !panel.hidden;
          this.closeCountryPanels();
          if (!isOpen) {
            panel.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');
            document.addEventListener('click', this.boundCloseCountryPanels);
            document.addEventListener('keydown', this.boundHandleEscape);
          }
        });

        panel.querySelectorAll('.localization-country-option').forEach((option) => {
          option.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            select.value = option.dataset.value;
            this.saveCountryPreference(option.dataset.value);
            this.updateCountrySelection(wrapper);
            this.updateIcons();
            this.closeCountryPanels();
            this.debouncedOnSubmit({ target: select });
          });
        });
      });
    }
    closeCountryPanels() {
      this.querySelectorAll('.localization-country-panel').forEach((panel) => {
        panel.hidden = true;
      });
      this.querySelectorAll('.localization-country-trigger').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      document.removeEventListener('click', this.boundCloseCountryPanels);
      document.removeEventListener('keydown', this.boundHandleEscape);
    }
    handleEscape(event) {
      if (event.key === 'Escape') this.closeCountryPanels();
    }
    updateCountrySelection(wrapper) {
      const select = wrapper.querySelector('select[name="country_code"]');
      if (!select) return;

      wrapper.querySelectorAll('.localization-country-option').forEach((option) => {
        option.classList.toggle('is-selected', option.dataset.value === select.value);
      });
    }
    updateIcons() {
      this.querySelectorAll('select[data-localization-type="country"]').forEach((select) => {
        const icon = select.closest('.localization-select--icon')?.querySelector('.localization-flag-icon');
        const option = select.options[select.selectedIndex];
        if (!icon || !option) return;

        const flagUrl = option.dataset.flag;
        if (flagUrl) {
          icon.src = flagUrl;
          icon.alt = option.dataset.label || option.text.trim();
        }

        const currencyCode = select.closest('.localization-select--icon')?.querySelector('.localization-currency-code');
        if (currencyCode && option.dataset.currency) {
          currencyCode.textContent = option.dataset.currency;
        }
      });

      this.querySelectorAll('select[data-localization-type="language"]').forEach((select) => {
        const code = select.closest('.localization-select--icon')?.querySelector('.localization-language-code');
        const option = select.options[select.selectedIndex];
        if (!code || !option) return;

        code.textContent = option.value.toUpperCase();
      });
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}
